import { useTenant } from '../../contexts/TenantContext';

export default function PrivacyPage() {
  const tenant = useTenant();

  return (
    <div
      className="min-h-screen py-12 px-4"
      style={{
        background: tenant.theme.colors.gradients.main,
        fontFamily: tenant.theme.fonts.body.family
      }}
    >
      <div className="max-w-4xl mx-auto">
        <div
          className="p-8 rounded-lg shadow-lg"
          style={{
            background: 'rgba(17, 24, 39, 0.95)',
            border: '1px solid rgba(51, 65, 85, 0.5)'
          }}
        >
          <h1
            className="text-4xl font-bold mb-6"
            style={{
              fontFamily: tenant.theme.fonts.primary.family,
              color: tenant.theme.colors.accent
            }}
          >
            Política de Privacidad
          </h1>

          <div className="space-y-6 text-gray-200 leading-relaxed">
            <p className="text-sm text-gray-400">
              Última actualización: Febrero 2026
            </p>

            <section>
              <h2
                className="text-2xl font-semibold mb-3"
                style={{ color: tenant.theme.colors.primary }}
              >
                1. Información que Recopilamos
              </h2>
              <p>
                En <strong style={{ color: tenant.theme.colors.accent }}>Neureka</strong>, recopilamos
                y procesamos la siguiente información:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-2 ml-4">
                <li>
                  <strong>Datos de cuenta:</strong> nombre, email, contraseña encriptada, fecha de registro
                </li>
                <li>
                  <strong>Datos de uso:</strong> juegos jugados, puntuaciones, tiempos, progreso y estadísticas
                </li>
                <li>
                  <strong>Datos de sesión:</strong> para profesionales, información de sesiones con pacientes
                </li>
                <li>
                  <strong>Datos técnicos:</strong> dirección IP, navegador, sistema operativo (para seguridad y mejoras)
                </li>
              </ul>
            </section>

            <section>
              <h2
                className="text-2xl font-semibold mb-3"
                style={{ color: tenant.theme.colors.primary }}
              >
                2. Cómo Usamos tu Información
              </h2>
              <p>Utilizamos tus datos para:</p>
              <ul className="list-disc list-inside mt-3 space-y-2 ml-4">
                <li>Proporcionar y mejorar nuestros servicios de entrenamiento cognitivo</li>
                <li>Generar estadísticas personalizadas de progreso y rendimiento</li>
                <li>Permitir a profesionales gestionar sesiones con sus pacientes</li>
                <li>Enviar notificaciones importantes relacionadas con tu cuenta</li>
                <li>Detectar y prevenir fraudes o uso indebido de la plataforma</li>
                <li>Cumplir con obligaciones legales</li>
              </ul>
            </section>

            <section>
              <h2
                className="text-2xl font-semibold mb-3"
                style={{ color: tenant.theme.colors.primary }}
              >
                3. Base Legal del Tratamiento (RGPD)
              </h2>
              <p>Procesamos tus datos bajo las siguientes bases legales:</p>
              <ul className="list-disc list-inside mt-3 space-y-2 ml-4">
                <li>
                  <strong>Ejecución de contrato:</strong> para proporcionar los servicios solicitados
                </li>
                <li>
                  <strong>Consentimiento:</strong> para comunicaciones no esenciales (si aplicable)
                </li>
                <li>
                  <strong>Interés legítimo:</strong> para mejorar nuestros servicios y seguridad
                </li>
                <li>
                  <strong>Obligación legal:</strong> cuando la ley lo requiera
                </li>
              </ul>
            </section>

            <section>
              <h2
                className="text-2xl font-semibold mb-3"
                style={{ color: tenant.theme.colors.primary }}
              >
                4. Compartir Datos con Terceros
              </h2>
              <p>
                <strong>NO vendemos ni compartimos tus datos personales con terceros</strong> con fines
                comerciales. Solo compartimos información cuando:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-2 ml-4">
                <li>Es necesario para proporcionar el servicio (ej: hosting, procesamiento de pagos)</li>
                <li>Lo requiere la ley o una orden judicial</li>
                <li>Es necesario para proteger nuestros derechos o la seguridad de los usuarios</li>
              </ul>
            </section>

            <section>
              <h2
                className="text-2xl font-semibold mb-3"
                style={{ color: tenant.theme.colors.primary }}
              >
                5. Seguridad de los Datos
              </h2>
              <p>
                Implementamos medidas de seguridad técnicas y organizativas para proteger tus datos:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-2 ml-4">
                <li>Contraseñas encriptadas con algoritmos seguros (bcrypt)</li>
                <li>Conexiones HTTPS cifradas en toda la plataforma</li>
                <li>Acceso restringido a datos personales solo para personal autorizado</li>
                <li>Copias de seguridad regulares para prevenir pérdida de datos</li>
                <li>Auditorías de seguridad periódicas</li>
              </ul>
            </section>

            <section>
              <h2
                className="text-2xl font-semibold mb-3"
                style={{ color: tenant.theme.colors.primary }}
              >
                6. Tus Derechos (RGPD)
              </h2>
              <p>Según el Reglamento General de Protección de Datos (RGPD), tienes derecho a:</p>
              <ul className="list-disc list-inside mt-3 space-y-2 ml-4">
                <li><strong>Acceso:</strong> solicitar una copia de tus datos personales</li>
                <li><strong>Rectificación:</strong> corregir datos inexactos o incompletos</li>
                <li><strong>Supresión:</strong> solicitar la eliminación de tus datos ("derecho al olvido")</li>
                <li><strong>Portabilidad:</strong> recibir tus datos en formato estructurado y legible</li>
                <li><strong>Oposición:</strong> oponerte al procesamiento de tus datos</li>
                <li><strong>Limitación:</strong> solicitar la restricción del tratamiento</li>
              </ul>
              <p className="mt-3">
                Para ejercer estos derechos, contacta con{' '}
                <a
                  href="mailto:privacidad@neureka.es"
                  className="underline"
                  style={{ color: tenant.theme.colors.accent }}
                >
                  privacidad@neureka.es
                </a>
              </p>
            </section>

            <section>
              <h2
                className="text-2xl font-semibold mb-3"
                style={{ color: tenant.theme.colors.primary }}
              >
                7. Cookies y Tecnologías Similares
              </h2>
              <p>
                Utilizamos cookies esenciales para el funcionamiento de la plataforma (autenticación,
                preferencias). No utilizamos cookies de terceros para publicidad o tracking.
              </p>
            </section>

            <section>
              <h2
                className="text-2xl font-semibold mb-3"
                style={{ color: tenant.theme.colors.primary }}
              >
                8. Retención de Datos
              </h2>
              <p>
                Conservamos tus datos mientras tu cuenta esté activa. Si eliminas tu cuenta, tus datos
                personales se borrarán en un plazo de 30 días, salvo que debamos conservarlos por
                obligaciones legales.
              </p>
            </section>

            <section>
              <h2
                className="text-2xl font-semibold mb-3"
                style={{ color: tenant.theme.colors.primary }}
              >
                9. Menores de Edad
              </h2>
              <p>
                Neureka está diseñado para mayores de 13 años. Si descubrimos que hemos recopilado
                datos de menores de 13 años sin consentimiento parental, eliminaremos esos datos de
                inmediato.
              </p>
            </section>

            <section>
              <h2
                className="text-2xl font-semibold mb-3"
                style={{ color: tenant.theme.colors.primary }}
              >
                10. Cambios en esta Política
              </h2>
              <p>
                Podemos actualizar esta política ocasionalmente. Te notificaremos de cambios significativos
                por email o mediante un aviso destacado en la plataforma.
              </p>
            </section>

            <section>
              <h2
                className="text-2xl font-semibold mb-3"
                style={{ color: tenant.theme.colors.primary }}
              >
                11. Contacto
              </h2>
              <p>
                Si tienes preguntas sobre esta política de privacidad, contacta con:
              </p>
              <div
                className="mt-3 p-4 rounded-lg"
                style={{ background: 'rgba(15, 23, 42, 0.6)' }}
              >
                <p><strong>Email:</strong> privacidad@neureka.es</p>
                <p><strong>Formulario:</strong> <a href="/contact" className="underline" style={{ color: tenant.theme.colors.accent }}>Página de contacto</a></p>
              </div>
            </section>

            <section className="pt-6 border-t border-gray-700">
              <p className="text-center text-gray-400 text-sm">
                Neureka cumple con el RGPD (Reglamento General de Protección de Datos) de la Unión Europea
                y la LOPD española.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
